module.exports = __webpack_public_path__ + "static/img/two-flex1.47947bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fusionIntegration/two-flex1.png
// module id = fzu3
// module chunks = 0